/** Поиск по всем штрихкодам, включая дополнительные. */
export function matchesProductSearch(p: { sku: string; name: string; article_1c?: string | null; barcodes?: string[] }, q: string): boolean {
  const look: Record<string,string> = { a:'а', b:'в', c:'с', e:'е', h:'н', k:'к', m:'м', o:'о', p:'р', t:'т', x:'х', y:'у' };
  const norm = (s: string) => s.toLowerCase().replace(/ё/g, 'е').replace(/[abcehkmoptxy]/g, (ch) => look[ch]);
  const needle = norm(q.trim());
  if (!needle) return false;
  if ((p.barcodes ?? []).some((code) => code.includes(q.trim()))) return true;
  const hay = norm(p.sku + ' ' + p.name + ' ' + (p.article_1c ?? ''));
  return needle.split(/\s+/).every((word) => hay.includes(word));
}

/** В приёмке наборы отсекаются сервером, а совпадения загружаются без обрезки. */
export async function fetchProductMatches<T extends { id: number }>(
  q: string, warehouseId: number | null, baseOnly: boolean, request: (url: string) => Promise<T[]>,
): Promise<T[]> {
  const limit = baseOnly ? 500 : 20;
  const all: T[] = [];
  const seen = new Set<number>();
  for (let offset = 0; ; offset += limit) {
    const params = new URLSearchParams({ search: q, limit: String(limit), offset: String(offset) });
    if (warehouseId !== null) params.set('warehouse_id', String(warehouseId));
    if (baseOnly) params.set('is_kit', 'false');
    const page = await request('/products?' + params);
    for (const p of page) if (!seen.has(p.id)) { seen.add(p.id); all.push(p); }
    if (!baseOnly || page.length < limit) return all;
  }
}
